const BRAND = process.env.REACT_APP_BRAND || "gtv";

export const applyBranding = async () => {
  applyIcons(BRAND);
  applyManifest(BRAND);
  applyTitle(BRAND);
};

const applyIcons = (brand) => {
  const links = [
    { rel: "icon", sizes: "16x16", file: "favicon-16x16.png" },
    { rel: "icon", sizes: "32x32", file: "favicon-32x32.png" },
    { rel: "apple-touch-icon", file: "apple-touch-icon.png" },
  ];

  // usuń stare
  document.querySelectorAll("[data-brand-icon]").forEach((el) => el.remove());

  links.forEach(({ rel, sizes, file }) => {
    const link = document.createElement("link");
    link.rel = rel;
    if (sizes) link.setAttribute("sizes", sizes);
    link.href = `/${brand}/${file}?v=${brand}`;
    link.setAttribute("data-brand-icon", "true");

    document.head.appendChild(link);
  });
};

const applyManifest = (brand) => {
  const manifestHref = `/${brand}/manifest.json?v=${brand}`;

  let link = document.querySelector("link[rel='manifest']");

  if (!link) {
    link = document.createElement("link");
    link.rel = "manifest";
    document.head.appendChild(link);
  }

  link.href = manifestHref;
};

const applyTitle = (brand) => {
  const titles = {
    gtv: "GTVBus App",
    ziplo: "Ziplo",
  };

  document.title = titles[brand] || "App";
};